export default __webpack_public_path__ + "static/media/iea-nantes.5e25671d.png";